// NPM Imports
import React, { Component, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SketchPicker } from "react-color";

// Components Imports

// Action Imports

// Internal Imports
import TableAddColumnRight from "../../../assets/table-icons/ic-column-add.svg";
import TableAddColumnLeft from "../../../assets/table-icons/ic-column-add-left.svg";
import TableRemoveColumn from "../../../assets/table-icons/ic-column-remove.svg";
import TableAddRowBelow from "../../../assets/table-icons/ic-row-add.svg";
import TableAddRowAbove from "../../../assets/table-icons/ic-row-add-up.svg";
import TableRemoveRow from "../../../assets/table-icons/ic-row-delete.svg";
import TableBorder from "../../../assets/table-icons/ic-border-color.svg";
import { DOCUMENTS } from "../../../constants";

// Destructuring
const { FONT_COLORS } = DOCUMENTS;

class TableOptions extends Component {
  tableOptionsDropdownRef = React.createRef();

  tableColorPickerRef = React.createRef();

  state = {
    showOptionsDropdown: false,
    showBgColorPicker: false,
    showBorderColorPicker: false,
    bgColorSelected: "#fff",
    borderColorSelected: "#fff",
    type: null,
  };

  componentDidMount = () => {
    const { section, activeCell } = this.props;
    if (activeCell !== null)
      this.setState({
        bgColorSelected: section.data.data[activeCell[0]].data[activeCell[1]]
          .attributes.bgColor
          ? section.data.data[activeCell[0]].data[activeCell[1]].attributes
              .bgColor
          : "fff",
        borderColorSelected: section.data.attributes.borderColor
          ? section.data.attributes.borderColor
          : "fff",
      });
  };

  componentWillUnmount = () => {
    this.props.disablePlusBtnHandler(false);
  };

  _toggleTableOptions = event => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();
    }
    // attach/remove event handler
    if (!this.state.showOptionsDropdown) {
      document.addEventListener(
        "onmousedown",
        this._handleTableOptionsOutsideClick,
        false,
      );
      this.props.disablePlusBtnHandler(true);
    } else {
      document.removeEventListener(
        "onmousedown",
        this._handleTableOptionsOutsideClick,
        false,
      );
      this.props.disablePlusBtnHandler(false);
    }
    this.setState(prevState => ({
      showOptionsDropdown: !prevState.showOptionsDropdown,
    }));
  };

  _handleTableOptionsOutsideClick = e => {
    const node = this.tableOptionsDropdownRef.current;
    const colorPickerNode = this.tableColorPickerRef.current;
    if (
      (node && node.contains(e.target)) ||
      (colorPickerNode && colorPickerNode.contains(e.target))
    ) {
      return;
    }
    this._toggleTableOptions();
  };

  _toggleColorPicker = (type, e) => {
    e.preventDefault();

    if (type === "BackgroundColor") {
      this.setState(prevState => ({
        showBgColorPicker: !prevState.showBgColorPicker,
        showBorderColorPicker: false,
        type,
      }));
    } else if (type === "BorderColor") {
      this.setState(prevState => ({
        showBgColorPicker: false,
        showBorderColorPicker: !prevState.showBorderColorPicker,
        type,
      }));
    }
  };

  _getOptions = () => {
    const options = [
      {
        id: "add_background_color",
        label: "Background Color",
        imgSrc: "",
        bottomBorder: false,
        actionMethod: this._toggleColorPicker,
        position: "BackgroundColor",
        enable: true,
      },
      {
        id: "add_border_color",
        label: "Border Color",
        imgSrc: TableBorder,
        bottomBorder: true,
        actionMethod: this._toggleColorPicker,
        position: "BorderColor",
        enable: true,
      },
      {
        id: "add_column_left",
        label: "Add Column Left",
        imgSrc: TableAddColumnLeft,
        bottomBorder: false,
        actionMethod: this.props.addColumn,
        position: "L",
        enable: this.props.enableAddColumn,
      },
      {
        id: "add_column_right",
        label: "Add Column Right",
        imgSrc: TableAddColumnRight,
        bottomBorder: false,
        actionMethod: this.props.addColumn,
        position: "R",
        enable: this.props.enableAddColumn,
      },
      {
        id: "remove_column",
        label: "Remove Column",
        imgSrc: TableRemoveColumn,
        bottomBorder: true,
        actionMethod: this.props.removeColumn,
        position: null,
        enable: this.props.enableRemoveColumn,
      },
      {
        id: "add_row_above",
        label: "Add Row Above",
        imgSrc: TableAddRowAbove,
        bottomBorder: false,
        actionMethod: this.props.addRow,
        position: "U",
        enable: this.props.enableAddRow,
      },
      {
        id: "add_row_below",
        label: "Add Row Below",
        imgSrc: TableAddRowBelow,
        bottomBorder: false,
        actionMethod: this.props.addRow,
        position: "D",
        enable: this.props.enableAddRow,
      },
      {
        id: "remove_row",
        label: "Remove Row",
        imgSrc: TableRemoveRow,
        bottomBorder: false,
        actionMethod: this.props.removeRow,
        position: null,
        enable: this.props.enableRemoveRow,
      },
    ];
    return options;
  };

  _handleOptionRowClick = (e, actionMethod, direction) => {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    if (direction !== "BackgroundColor" && direction !== "BorderColor") {
      this.setState({ showOptionsDropdown: false });
    }
    if (direction) {
      actionMethod(direction, e);
    } else {
      actionMethod(e);
    }
  };

  _resetDropdowns = position => {
    if (position !== "BackgroundColor" && position !== "BorderColor")
      this.setState({
        showBorderColorPicker: false,
        showBgColorPicker: false,
      });
  };

  render() {
    const tableOptions = this._getOptions();
    let selectedColor;
    if (this.state.showBgColorPicker) {
      selectedColor = this.state.bgColorSelected;
    } else if (this.state.showBorderColorPicker) {
      selectedColor = this.state.borderColorSelected;
    }
    return (
      <div
        className={`tableoptions-container ${
          this.props.mode === "TEMPLATE" ? "template-case" : ""
        }`}
        ref={this.props.optionRef}>
        <span
          className="tableoptions-dropdown-icon"
          onMouseDown={this._toggleTableOptions}
          onKeyPress={() => {}}
          role="button"
          tabIndex="0"
          data-test="tableoptions-dropdown-icon">
          <FontAwesomeIcon icon={["far", "ellipsis-v"]} />
        </span>

        {this.state.showOptionsDropdown && (
          <div
            ref={this.tableOptionsDropdownRef}
            className="tableoptions-dropdown-wrapper">
            {tableOptions.map(option =>
              option.enable ? (
                <Fragment>
                  <div
                    className={`tableoptions-row ${
                      (this.state.showBgColorPicker &&
                        option.label === "Background Color") ||
                      (this.state.showBorderColorPicker &&
                        option.label === "Border Color")
                        ? "active"
                        : ""
                    }`}
                    onMouseDown={e => {
                      this._resetDropdowns(option.position);
                      this._handleOptionRowClick(
                        e,
                        option.actionMethod,
                        option.position,
                      );
                    }}
                    onKeyDown={() => {}}
                    role="button"
                    tabIndex={0}>
                    {option.position === "BackgroundColor" && (
                      <span
                        data-test="table-background-color"
                        className="btn-positive tableoptions-color-icon">
                        <i>
                          <FontAwesomeIcon icon={["far", "fill-drip"]} />
                        </i>
                      </span>
                    )}
                    {option.position !== "BackgroundColor" && (
                      <span className="btn-positive tableoptions-action-icon">
                        <img
                          className="tableoptions-action-img"
                          src={option.imgSrc}
                          alt="Add Row Column"
                        />
                      </span>
                    )}
                    <span className="tableoptions-action-label">
                      {option.label}
                    </span>
                  </div>
                  {option.bottomBorder && (
                    <hr className="tableoptions-row-hr" />
                  )}
                </Fragment>
              ) : null,
            )}
          </div>
        )}

        {(this.state.showBgColorPicker || this.state.showBorderColorPicker) &&
          this.state.type && (
            <div
              id="table-options-color-picker"
              ref={this.props.tableOptionsColorPickerRef}>
              <div
                ref={this.tableColorPickerRef}
                className="table-customcolor-dropdown-wrapper table-options-picker"
                role="button"
                tabIndex={0}
                onMouseDown={e => {
                  e.preventDefault();
                }}>
                <SketchPicker
                  color={selectedColor}
                  onChange={event => {
                    if (this.state.type === "BackgroundColor") {
                      this.setState({
                        bgColorSelected: event.hex,
                        borderColorSelected: "#fff",
                      });
                      this.props.applyBackgroundColor(event);
                    }
                    if (this.state.type === "BorderColor") {
                      this.setState({
                        borderColorSelected: event.hex,
                        bgColorSelected: "#fff",
                      });
                      this.props.applyBorderColor(event);
                    }
                  }}
                  presetColors={FONT_COLORS}
                  width={225}
                  disableAlpha
                  data-test="color-option-picker"
                />
              </div>
            </div>
          )}
      </div>
    );
  }
}

export default TableOptions;



// WEBPACK FOOTER //
// ./src/components/RevvTable/TableOptions/index.js